import { getMoscowDateTime } from './getMoscowDateTime'

//Диапазон по умолчанию считается по московскому времени, независимо от таймзоны браузера
export const getLast30DaysDateRange = () => {
  const endDate = getMoscowDateTime() // текущий момент

  const startDate = new Date(endDate)
  startDate.setDate(startDate.getDate() - 30)
  startDate.setHours(0, 0, 0, 0) // 00:00:00.000 за 30 дней до текущей даты

  return {
    startDate,
    endDate,
  }
}
